function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.749h30v15H0V7.749Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.336 8.419 15 7.749 13.322 7.749 7.5 10.66 1.678 7.749 0 7.749 0 8.587 5.822 11.498 0 14.41 0 15.249 .335 15.919 7.5 12.337 14.664 15.919 15.336 14.578 9.177 11.498 15.336 8.419",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.224 8.196 15 7.749 13.881 7.749 7.5 10.939 1.119 7.749 0 7.749 0 8.308 6.382 11.498 0 14.689 0 15.248 .223 15.696 7.5 12.058 14.777 15.696 15.224 14.801 8.617 11.498 15.224 8.196",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.75 10.249 8.75 7.749 6.25 7.749 6.25 10.249 0 10.249 0 12.748 6.25 12.748 6.25 15.499 8.75 15.499 8.75 12.748 15.5 12.748 15.5 10.249 8.75 10.249",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.249 15.499 6.75 15.499 6.75 12.249 0 12.249 0 10.748 6.75 10.748 6.75 7.749 8.249 7.749 8.249 10.748 15.5 10.748 15.5 12.249 8.249 12.249 8.249 15.499",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.749h15v15H0v-7.5h15s0-7.5,0-7.5Z",
    style: {
      fill: "#009cde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M16.375,19.935l.773,2.377-2.022-1.469h2.5l-2.022,1.469.773-2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M19.5,18.688l-.773-2.377,2.022,1.469h-2.5l2.022-1.469-.773,2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M19.5,21.813l-.773-2.377,2.022,1.469h-2.5l2.022-1.469-.773,2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d2",
    "data-name": "d",
    d: "M22.625,14.438l-.773-2.377,2.022,1.469h-2.501l2.022-1.469-.772,2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3",
    "data-name": "d",
    d: "M22.625,20.938l-.773-2.377,2.022,1.469h-2.501l2.022-1.469-.772,2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d4",
    "data-name": "d",
    d: "M25.25,13.438l-.773-2.377,2.022,1.469h-2.5l2.022-1.469-.773,2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1",
    "data-name": "c",
    d: "M25.25,16.059l.773,2.377-2.022-1.469h2.5l-2.022,1.469.773-2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2",
    "data-name": "c",
    d: "M27.874,8.435l.773,2.377-2.022-1.469h2.5l-2.022,1.469.773-2.377Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c3",
    "data-name": "c",
    d: "M27.874,14.434l.773,2.377-2.022-1.469h2.5l-2.022,1.469.773-2.377Z",
    style: {
      fill: "#fedd00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.70bfa03a4eea40e9c4d94b31f31d2f1a.svg";
export { ForwardRef as ReactComponent };